import React from "react"
import { Grid } from "@mui/material"

import { AppAntSwitch, AppProvidersAutocomplete, AppTiersAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { BACKEND_APIS } from "@constants"


export default function AlertsProviders() {

	const {
		dataInfo: excludeProviders, setDataInfo: setExcludeProviders
	} = useAlertsDataInfo(alertsDrawerData.peek().excludeProviders || false)

	const {
		dataInfo: providers, setDataInfo: setProviders
	} = useAlertsDataInfo(alertsDrawerData.peek().providers || [])

	const { dataInfo: tiers, setDataInfo: setTiers } = useAlertsDataInfo(alertsDrawerData.peek().tiers || [])

	const {
		dataInfo: providersByTiers, setDataInfo: setProvidersByTiers
	} = useAlertsDataInfo(alertsDrawerData.peek().providersByTiers || [])


	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<AppAntSwitch
				trueText="Exclude"
				falseText="Include"
				checked={excludeProviders.value}
				onChange={e => setExcludeProviders(e.target.checked, 'excludeProviders')}
			/>

		</Grid>
		<Grid item xs={6}>
			<AppTiersAutocomplete
				multiple
				value={tiers.value}
				onChange={e => {
					setProviders(e.target.value.reduce((acc, curr) => [...acc, ...providersByTiers.value.find(t => t.key === curr).providers], []), 'providers')
					setTiers(e.target.value, 'tiers')
				}}
				onFinishAjax={options => {
					setProvidersByTiers(options.map(t => ({
						key: t.value, providers: t.providers
					})), 'providersByTiers')
				}}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
			/>
		</Grid>
		<Grid item xs={6}>
			<AppProvidersAutocomplete
				value={providers.value}
				onChange={e => setProviders(e.target.value, 'providers')}
				disabled={!!tiers.value.length}
			/>
		</Grid>
	</Grid>

}